import { useFormikContext } from "formik"
import RecordsSelect from "components/timenotes/records-select"
import { TApiClient } from "@timenotes/shared/src/services/api-client/types"
import { useClientsQuery } from "@timenotes/shared/src/services/clients/queries/use-clients-query"

const DEFAULT_STYLE: React.CSSProperties = {
  width: '100%'
}

interface ClientSelectFieldProps {
  name: string
  allowClear?: boolean
  placeholder?: string
  style?: React.CSSProperties
}

const ClientSelectField = (props: ClientSelectFieldProps) => {
  const {
    name,
    allowClear = true,
    placeholder = "Select the client",
    style = {}
  } = props

  const formik = useFormikContext<any>()
  const clientsQuery = useClientsQuery()
  const clientsOptions = clientsQuery.isSuccess ? clientsQuery.data.clientsOptions : []

  return (
    <RecordsSelect<TApiClient>
      loading={clientsQuery.isLoading}
      placeholder={placeholder}
      allowClear={allowClear}
      onClear={() => {
        formik.setFieldValue(name, null)
      }}
      style={{
        ...DEFAULT_STYLE,
        ...style
      }}
      value={clientsOptions.find(clientOption => clientOption.value.id === formik.getFieldProps(name).value)?.value}
      valueProp="id"
      labelProp="name"
      searchProp="name"
      showSearch={true}
      onChange={(client) => {
        formik.setFieldValue(name, client?.id || null)
      }}
      options={clientsOptions}
    />
  )
}

export default ClientSelectField